import { Divider, Stack } from '@mui/material';

import { PropertyPanel as SetupPanel } from '@/modules/setupV2';
import { Layout as LayoutPanel } from './propertyPanel/layout';
import { SimulationPanel } from '@/modules/simulation/components/SimulationPanel/SimulationPanel';
import { PropertyPanel as VisualizationPanel } from '@/modules/visualization/components/PropertyPanel';
import { TabsMain } from '@/modules/propertyPanelV2/TabsMain';
import { useAppStore } from '@/modules/app/store/useAppStore';

export function PropertyPanel() {
  const activeModule = useAppStore((state) => state.activeModule);
  const modulesWithTabs = ['canvas_setup', 'canvas_layout', 'canvas_simulation'];
  return (
    <Stack sx={{ height: '100%' }}>
      {modulesWithTabs.includes(activeModule) && <TabsMain />}
      <Stack
        sx={{
          flex: '1 1 auto',
          overflowY: 'scroll',
          scrollbarWidth: 'none',
          '&:hover': { cursor: 'default' },
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        divider={<Divider />}
        spacing={1}
      >
        {activeModule === 'canvas_setup' && <SetupPanel />}
        {activeModule === 'canvas_layout' && <LayoutPanel />}
        {activeModule === 'canvas_simulation' && <SimulationPanel />}
        {(activeModule === 'canvas_viewer' || activeModule === 'visualization') && (
          <VisualizationPanel />
        )}
      </Stack>
      {/* <Testing /> */}
    </Stack>
  );
}
